import { termosStep } from '../../shared/termosSections';
import { inscricaoReferenciaSection, porCategoriaOuInscricaoReferencia } from '../../shared/juntadaSections';

const pedidoJuntadaDiligenciaConfig = {
  id: 'pedido_JuntadaDiligencia',
  nome: 'Pedido de Juntada de Diligência',
  categoria: 'pedidos',
  descricao: 'Solicitação de juntada de diligência',
  icon: 'FaTrashAlt',

  documentConfig: {
    documentosAdicionais: true,
    required: [
      { 
        id: 'manifestacao_diligencia', tipoDocumentoProcesso: 488, 
        name: 'Manifestação da Diligência', 
        description: 'Documento contendo a manifestação da diligência.', 
        required: true 
      },
    ],
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: porCategoriaOuInscricaoReferencia({ 'ADVOGADO(A)': '281', 'ESTAGIÁRIO(A)': '285' }),
    tiposAssunto: '826',
    tipoPedido: porCategoriaOuInscricaoReferencia({ 'ADVOGADO(A)': '481', 'ESTAGIÁRIO(A)': '482' })
  },

  // Confirmado ao vivo contra GET /modelo-requerimento/{281,285}/campos: só 2 campos.
  dadosRequerimentoConfig: {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'cpf', campoNome: 'CPFCNPJ' }
    ]
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
        inscricaoReferenciaSection
      ]
    },
    termosStep()
  ]
};

export default pedidoJuntadaDiligenciaConfig;